<app-simple-modal
    [title]="edit ? 'Editar contraseña' : 'Agregar contraseña'"
    [max]="50"
    (close)="cancel()">

    <div fields>

        <!-- Buscar empresa al crear -->
        <div class="form-group" *ngIf="!edit">

            <label for="company" class="form-label">
                Empresa
                <i class="fa fa-asterisk text-danger"></i>
            </label>

            <div class="input-group">

                <app-input-autocomplete
                    (changeStatus)="selectCompany($event.filterElement)"
                    (inputMethod)="searchCompany()"
                    [allBorderRadius]="true"
                    [filterElements]="companies"
                    [placeholder]="'Busca una empresa activa'"
                    [custom]="true"
                    [inputs]="inputs">

                    <ng-template #itemsTemplate let-filter>

                        <div items>

                            <h5
                                class="text-info"
                                style="line-height: normal; margin-bottom: 0;">

                                {{ filter.name }}

                            </h5>

                            <span
                                class="text-muted"
                                style="color: white !important;">

                                {{ filter.alphanumericId }}
                                -
                                NIT:
                                <b>{{ filter.nit }}</b>

                            </span>

                        </div>

                    </ng-template>

                </app-input-autocomplete>

            </div>

            <small class="form-text text-muted">
                Puedes registrar información para cualquier empresa activa.
            </small>

            <app-loading-animation
                *ngIf="gettingCompanies"
                [height]="'3rem'">
            </app-loading-animation>

        </div>

        <!-- Empresa al editar -->
        <div class="form-group" *ngIf="edit">

            <label for="editCompany" class="form-label">
                Empresa
            </label>

            <input
                type="text"
                class="form-control"
                name="editCompany"
                id="editCompany"
                [value]="editCompanyName"
                disabled>

        </div>

        <!-- Selección de tipo -->
        <div class="form-group mb-3">

            <label for="type" class="form-label">
                Tipo de contraseña
                <i class="fa fa-asterisk text-danger"></i>
            </label>

            <select
                class="form-control"
                id="type"
                name="type"
                [(ngModel)]="request.type">

                <option [ngValue]="null">
                    Selecciona un tipo
                </option>

                <option
                    *ngFor="let type of types"
                    [ngValue]="type.value">

                    {{ type.name }}

                </option>

            </select>

            <small class="form-text text-muted">
                Cada empresa puede tener únicamente una contraseña
                por tipo.
            </small>

        </div>

        <!-- Contraseña -->
        <div class="form-group mb-3">

            <label for="pass" class="form-label">
                {{ edit ? 'Nueva contraseña' : 'Contraseña' }}
                <i class="fa fa-asterisk text-danger"></i>
            </label>

            <input
                type="password"
                class="form-control"
                id="pass"
                name="pass"
                [(ngModel)]="request.pass"
                autocomplete="new-password"
                placeholder="Ingresa la contraseña">

        </div>

        <!-- Confirmación -->
        <div class="form-group mb-3">

            <label for="confirmPass" class="form-label">
                Confirmación
                <i class="fa fa-asterisk text-danger"></i>
            </label>

            <input
                type="password"
                class="form-control"
                id="confirmPass"
                name="confirmPass"
                [(ngModel)]="confirmPass"
                autocomplete="new-password"
                placeholder="Ingresa nuevamente la contraseña">

            <span
                class="form-text text-danger"
                *ngIf="confirmPass && request.pass &&
                       confirmPass !== request.pass">

                <i class="fa fa-circle-info"></i>
                Las contraseñas deben coincidir.

            </span>

        </div>

    </div>

    <div buttons>

        <button
            type="button"
            class="btn btn-secondary mr-2"
            (click)="cancel()">

            CANCELAR

        </button>

        <app-loading-button
            [object]="buttonSave"
            (clicked)="savePassBusiness()"
            [disabled]="!isValid() || buttonSave.loading">
        </app-loading-button>

    </div>

</app-simple-modal>